import axiosInstance from "../axios/axiosConfig";
import { CLASS_API } from "../constants/api-constants";
import { getI18nLanguageFromLocalStorage } from "../helpers/localStorageHelper";

export const getClassInformation = async (publicId) => {
  const lang = getI18nLanguageFromLocalStorage();
  const res = await axiosInstance.get(`${CLASS_API.GET_INFORMATION}/${publicId}`, {
    params: { lang },
  });
  return { data: res?.data };
};

export const getClassTrainer = async (trainerPublicId) => {
  const res = await axiosInstance.get(`${CLASS_API.GET_TRAINER}/${trainerPublicId}`);
  return { data: res?.data };
};

export const getRelatedClasses = async (publicId) => {
  const res = await axiosInstance.get(`${CLASS_API.GET_RELATED}/${publicId}`);
  return Array.isArray(res?.data) ? res.data : [];
};

export const getClassRatingDetails = async (body, productPublicId) => {
  const res = await axiosInstance.post(`${CLASS_API.GET_RATINGS}/${productPublicId}`, body || { first: 0, rows: 2, filters: {} });
  return res;
};

export const getClassRatingPercent = async (productPublicId) => {
  const res = await axiosInstance.get(`${CLASS_API.GET_RATINGS_PERCENT}/${productPublicId}/percent`);
  return { data: res?.data ?? [] };
};

export const canUserRatingForClassAsync = async (productPublicId) => {
  const res = await axiosInstance.get(`${CLASS_API.GET_RATINGS_CAN_RATING}/${productPublicId}/can-rating`);
  return { data: res?.data ?? false };
};

export const createRatingForClass = async (body, productPublicId) => {
  const res = await axiosInstance.post(`${CLASS_API.POST_RATINGS_CREATE}/${productPublicId}/create`, body);
  return { data: res?.data };
};

export const getClassList = async (paginationParams, filterRequest) => {
  const payload = filterRequest ? { paginationParams, filterRequest } : { paginationParams };
  const page = paginationParams?.rows ? Math.floor((paginationParams.first || 0) / paginationParams.rows) + 1 : 1;
  const pageSize = paginationParams?.rows ?? 12;
  const fallback = { data: [], pagingInfo: { page, pageSize, pageCount: 0, totalRecordCount: 0 } };
  try {
    const res = await axiosInstance.post(CLASS_API.GET_LIST, payload);
    const result = res?.data;
    return {
      data: result?.data ?? [],
      pagingInfo: result?.pagingInfo ?? fallback.pagingInfo,
    };
  } catch {
    return fallback;
  }
};
